import { useLayoutEffect, useRef } from 'preact/hooks';
import {
  useCheckoutContext,
  useSelector,
} from '@primer-io/shared-library/contexts';
import {
  CheckoutOptions,
  SinglePaymentMethodCheckoutOptions,
  VaultManagerOptions,
} from '../types';

import { useIsFirstRender } from '../utils/hooks';

const canDisplayProcessingIndicator = (
  options:
    | CheckoutOptions
    | VaultManagerOptions
    | SinglePaymentMethodCheckoutOptions,
) => {
  let canDisplay;
  const displaySubmitButton = options.submitButton?.visible !== false;
  if (displaySubmitButton) {
    // false by default (already handled by button)
    canDisplay = options.processingIndicator?.visible ?? false;
  } else {
    // true by default (not handled by button)
    canDisplay = options.processingIndicator?.visible ?? true;
  }

  return canDisplay;
};

const ProcessingIndicator = () => {
  const rootRef = useRef(null);
  const { viewUtils, options } = useCheckoutContext();
  const isProcessing = useSelector((s) => s.isProcessing);
  const isFirstRender = useIsFirstRender();

  const canDisplay = canDisplayProcessingIndicator(options);

  useLayoutEffect(() => {
    viewUtils.toggleVisibilityAnimated(
      rootRef.current,
      canDisplay ? isProcessing : false,
      {
        id: 'processing-indicator',
        duration: isFirstRender ? 0 : 500,
      },
    );
  }, [isProcessing]);

  return (
    <div ref={rootRef} class='PrimerCheckout__processingIndicatorOverlay'>
      <div class='PrimerCheckout__processingIndicatorContainer'>
        <div class='PrimerCheckout__spinner'>
          <svg class='spinner' viewBox='0 0 50 50'>
            <circle
              class='path'
              cx='25'
              cy='25'
              r='20'
              fill='none'
              stroke-width='5'
            ></circle>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default ProcessingIndicator;
